import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import RectangularButton from '../../../components/buttons/RectangularButton';
import { useWindowDimensions } from '../../../utils/windowsDimensions';

const QR_CODE_SIZE_MODIFIER = 0.8;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

interface Props {
  checkoutLink: string;
}

const CheckoutLinkPopup = ({ checkoutLink }: Props) => {
  const copyToClipboard = () => navigator.clipboard.writeText(checkoutLink);
  const { height } = useWindowDimensions();
  const { t } = useTranslation('onsite');

  return (
    <Container>
      <QRCodeSVG value={checkoutLink} size={height * QR_CODE_SIZE_MODIFIER} />
      <RectangularButton label={t('order.copy-to-clipboard')} onClick={copyToClipboard} />
    </Container>
  );
};

export default CheckoutLinkPopup;
